import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

import Dropdown from '../../../../shared/components/dropdown'
import SortByDropdown from './sortByDropdown'
import VideoControllsContainer from '../../../../shared/pages/search/result/video/videoControllsContainer'
import UsDollarsNoticeContainer from '../../../../shared/components/usDollarsNotice/usDollarsNoticeContainer'
import CalendarIcon from '../../../../shared/components/icons/calendar'
import LayoutSwitcher from '../../../../shared/components/layoutSwitcher'

const dateFilterLabels = [
  'Any date',
  'In the last year',
  'In the last month',
  'In the last week',
  'In the last day'
]

const SearchResultHeader = ({
  currentSite,
  locationParams,
  location,
  date,
  preferences,
  history,
  push,
  makeSearchLink
}) => {
  const view = preferences.searchResultsViewType

  const shouldShowVideoControlls = currentSite === 'videohive'

  const onDateSelectionChange = event => {
    let date = event.target.value

    let newQuery = Object.assign({}, locationParams, {
      date
    })

    delete newQuery.page

    if (newQuery.date === '') {
      delete newQuery.date
    }

    history.push(makeSearchLink(newQuery))
  }

  const getSelectDateDefaultValue = () => {
    return locationParams.date || ''
  }

  const renderDateFilter = () => {
    const selectedDateFilterIndex = date
      .map(d => d.key)
      .indexOf(locationParams.date || '')
    // build the date options
    const dateFilterOptions = date.map((d, index) => {
      const label = dateFilterLabels[index]
      return {
        value: d.key,
        label: index === selectedDateFilterIndex ? `Added: ${label}` : label
      }
    })

    return (
      <div className="inline-select-wrapper -hide-phone">
        <div className="search-facet-header--horizontal">
          <h2>
            <CalendarIcon title="Added" />
          </h2>
        </div>
        <div className="-border-top-none -border-radius-none inline-select">
          <label htmlFor="dateAdded" className="fds-u-is-visually-hidden">
            Added
          </label>
          <Dropdown
            id="dateAdded"
            name="date"
            options={dateFilterOptions}
            onChange={onDateSelectionChange}
            value={getSelectDateDefaultValue()}
          />
        </div>
      </div>
    )
  }

  return (
    <div id="search-result-header">
      <div className="fds-u-is-hidden--no-js search-facet-horizontal-form">
        {shouldShowVideoControlls && <VideoControllsContainer />}
      </div>
      <div className="fds-u-is-hidden--no-js search-facet-horizontal-form">
        <SortByDropdown
          push={push}
          locationParams={locationParams}
          currentSite={currentSite}
          makeSearchLink={makeSearchLink}
        />
        {renderDateFilter()}
        <LayoutSwitcher
          locationParams={locationParams}
          currentSite={currentSite}
          currentView={view}
        />
        <UsDollarsNoticeContainer />
      </div>
    </div>
  )
}

SearchResultHeader.propTypes = {
  locationParams: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  date: PropTypes.array,
  view: PropTypes.string,
  preferences: PropTypes.object,
  usDollarsNotice: PropTypes.string,
  push: PropTypes.func.isRequired,
  makeSearchLink: PropTypes.func.isRequired
}

SearchResultHeader.defaultProps = {
  date: []
}

export const SearchResultHeaderComponent = SearchResultHeader
export default withRouter(SearchResultHeader)
